import React from "react";
import { getRoomMetrics } from "../../../engine/metrics";
import { inr, mm2m } from "../../../utils/coords";
import { Row, SectionHead, mono } from "./PanelAtoms";

export function LayoutSummary({ st, boq }) {
  const rooms    = Object.keys(st.faces||{});
  const walls    = Object.keys(st.edges||{});
  const openings = Object.keys(st.openings||{});
  const syms     = Object.keys(st.symbols||{});
  const totalAreaM2 = rooms.reduce((sum,fId)=>{
    const f=(st.faces||{})[fId]; return f?sum+f.area/1e6:sum;
  }, 0);
  const totalWallLength = walls.reduce((sum,eId)=>{
    const e=(st.edges||{})[eId];
    const ab=(st.halfEdges||{})[e?.halfEdgeA], ba=(st.halfEdges||{})[e?.halfEdgeB];
    if(!ab||!ba) return sum;
    const nA=(st.nodes||{})[ab.originId], nB=(st.nodes||{})[ba.originId];
    if(!nA||!nB) return sum;
    return sum+Math.sqrt((nB.x-nA.x)**2+(nB.y-nA.y)**2);
  }, 0);
  return (
    <div style={{ padding:"8px 12px 6px" }}>
      <div style={{ padding:"8px 10px", background:"#06111e",
        border:"1px solid #0d1520", borderRadius:4, marginBottom:8 }}>
        <div style={{ fontSize:8, color:"#2a3a4a", letterSpacing:1, marginBottom:3, ...mono }}>TOTAL COST</div>
        <div style={{ fontSize:20, fontWeight:800, color:"#e8a838", ...mono }}>{inr(boq.totalCost)}</div>
        <div style={{ fontSize:8, color:"#2a3a4a", marginTop:2, ...mono }}>
          {inr(boq.wallCost+boq.labourCost)} structure · {inr(boq.roomCost)} finishes
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:4, marginBottom:8 }}>
        {[{l:"Rooms",v:rooms.length,c:"#4ade80"},{l:"Walls",v:walls.length,c:"#3b82f6"},
          {l:"Openings",v:openings.length,c:"#e8a838"},{l:"Symbols",v:syms.length,c:"#a78bfa"}
        ].map(({l,v,c})=>(
          <div key={l} style={{ background:"#06111e", border:"1px solid #0d1520", borderRadius:3, padding:"5px 8px" }}>
            <div style={{ fontSize:14, fontWeight:800, color:c, ...mono }}>{v}</div>
            <div style={{ fontSize:8, color:"#2a3a4a", ...mono }}>{l.toUpperCase()}</div>
          </div>
        ))}
      </div>
      <Row label="Total area">{totalAreaM2.toFixed(1)} m²</Row>
      <Row label="Wall length">{(totalWallLength/1000).toFixed(1)} m</Row>
      {boq.bricks>0  && <Row label="Bricks">{boq.bricks.toLocaleString("en-IN")}</Row>}
      {boq.cement>0  && <Row label="Cement">{boq.cement.toFixed(0)} bags</Row>}
      {boq.sand>0    && <Row label="Sand">{boq.sand.toFixed(0)} cft</Row>}
      <SectionHead color="#4ade80">ROOM SCHEDULE</SectionHead>
      {Object.keys(st.faces||{}).map(fId=>{
        const r=getRoomMetrics(fId,st); if(!r) return null;
        return (
          <div key={fId} style={{ padding:"3px 12px", borderBottom:"1px solid #06111e" }}>
            <div style={{ display:"flex", justifyContent:"space-between" }}>
              <span style={{ fontSize:10, color:"#6b7e94" }}>{r.tmpl.icon} {r.rd.name||r.tmpl.label}</span>
              <span style={{ fontSize:10, color:"#4ade80" }}>{r.areaM2.toFixed(1)} m²</span>
            </div>
            <div style={{ fontSize:8.5, color:"#2a3a4a", marginTop:1 }}>
              {inr(r.totalCost)} · {mm2m(r.perimMm)}m
            </div>
          </div>
        );
      })}
      <SectionHead color="#3b82f6">WALLS</SectionHead>
      {Object.keys(st.edges||{}).map(eId=>{
        const e=(st.edges||{})[eId];
        const ab=(st.halfEdges||{})[e?.halfEdgeA], ba=(st.halfEdges||{})[e?.halfEdgeB];
        if(!ab||!ba) return null;
        const nA=(st.nodes||{})[ab.originId], nB=(st.nodes||{})[ba.originId];
        if(!nA||!nB) return null;
        const len=Math.round(Math.sqrt((nB.x-nA.x)**2+(nB.y-nA.y)**2));
        return (
          <div key={eId} style={{ padding:"3px 12px", borderBottom:"1px solid #06111e" }}>
            <div style={{ display:"flex", justifyContent:"space-between" }}>
              <span style={{ fontSize:10, color:"#6b7e94" }}>{e.materialId||"BRICK"}</span>
              <span style={{ fontSize:10, color:"#3b82f6" }}>{len>=1000?`${(len/1000).toFixed(2)}m`:`${len}mm`}</span>
            </div>
            <div style={{ fontSize:8.5, color:"#2a3a4a", marginTop:1 }}>{e.thickness}mm thick</div>
          </div>
        );
      })}
    </div>
  );
}
